import { CUSTOMS_CODE_COUNTRIES } from '../constants/locations';

export const customsCodeIsRequired = (countryCode?: string | null) => {
  return countryCode ? CUSTOMS_CODE_COUNTRIES.includes(countryCode) : false;
};
